import AuthClient from './lib/client';
export default AuthClient;
//# sourceMappingURL=browser.js.map